import { render, staticRenderFns } from "./AddOrEditPlatformDetail.vue?vue&type=template&id=59d4630e&scoped=true"
import script from "./AddOrEditPlatformDetail.vue?vue&type=script&lang=js"
export * from "./AddOrEditPlatformDetail.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditPlatformDetail.vue?vue&type=style&index=0&id=59d4630e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d4630e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d4630e')) {
      api.createRecord('59d4630e', component.options)
    } else {
      api.reload('59d4630e', component.options)
    }
    module.hot.accept("./AddOrEditPlatformDetail.vue?vue&type=template&id=59d4630e&scoped=true", function () {
      api.rerender('59d4630e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryPlatform/AddOrEditPlatformDetail.vue"
export default component.exports